import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import Product from ".././assets/gallery/pg4.webp";
import Partition from ".././assets/gallery/p1.jpg";
import Slider from ".././assets/gallery/sliderCover.jpg";
import Door from ".././assets/gallery/d2.jpg";

import "./Home.css";

const Products = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="pb-24"> {/* Added padding-bottom to prevent footer overlap */}
      {/* Products Section */}
      <div className="flex flex-col justify-center md:pt-32 bg-white">
        <h3 className="text-4xl md:text-6xl text-center leading-8 font-montserrat font-medium tracking-wide md:tracking-widest text-black">
          EXPLORE OUR PRODUCTS
        </h3>
        <p className="font-montserrat font-medium text-center md:space-x-5 space-y-3 md:space-y-0 max-w-full md:max-w-7xl mx-auto px-10 pt-6 pb-10 text-md text-black">
          Discover our range of high-end aluminum systems, including pergolas, partitions, doors, and sliders. Each product is designed to combine luxury, durability, and functionality.
        </p>

        {/* Product Grid */}
        <div className="grid md:grid-cols-2 grid-cols-1 gap-16 max-w-7xl mx-auto px-6 md:px-12">
          {/* Aluminum Pergola Systems */}
          <div
            className="w-full bg-white transform transition duration-500 hover:scale-105"
            data-aos="fade-up"
          >
            <Link to="pergolas">
              <img
                src={Product}
                alt="Aluminum Pergola Systems"
                className="object-cover w-full h-full"
              />
            </Link>
            <h3 className="font-montserrat font-bold text-center block pb-3 text-lg md:text-2xl tracking-wide pt-4 text-black">
              Aluminum Pergola Systems
            </h3>
          </div>

          {/* Aluminum Partition Systems */}
          <div
            className="w-full bg-white transform transition duration-500 hover:scale-105"
            data-aos="fade-up"
          >
            <Link to="partitions">
              <img
                src={Partition}
                alt="Aluminum Partition Systems"
                className="object-cover w-full h-full"
              />
            </Link>
            <h3 className="font-montserrat font-bold text-center block pb-3 text-lg md:text-2xl tracking-wide pt-4 text-black">
              Aluminum Partition Systems
            </h3>
          </div>

          {/* Aluminum Door Systems */}
          <div
            className="w-full bg-white transform transition duration-500 hover:scale-105"
            data-aos="fade-up"
          >
            <Link to="doors">
              <img
                src={Door}
                alt="Aluminum Door Systems"
                className="object-cover w-full h-full"
              />
            </Link>
            <h3 className="font-montserrat font-bold text-center block pb-3 text-lg md:text-2xl tracking-wide pt-4 text-black">
              Aluminum Door Systems
            </h3>
          </div>

          {/* Aluminum Sliding Systems */}
          <div
            className="w-full bg-white transform transition duration-500 hover:scale-105"
            data-aos="fade-up"
          >
            <Link to="sliders">
              <img
                src={Slider}
                alt="Aluminum Sliding Systems"
                className="object-cover w-full h-full"
              />
            </Link>
            <h3 className="font-montserrat font-bold text-center block pb-3 text-lg md:text-2xl tracking-wide pt-4 text-black">
              Aluminum Sliding Systems
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
